<div id="editeur">
    <div id="toolbox_container">
        <app-toolbox></app-toolbox>
    </div>
    <div id="editeur-container">
        @if (espace$ | async; as espace) {
        <mat-drawer-container [hasBackdrop]="false">
            <mat-drawer-content id="treeview_drawer" class="treeview">
                @if ((viewLayout$ | async) === 'tree') { @if (racine$ | async) {
                <app-treeview> </app-treeview>
                } } @else {
                <app-graph></app-graph>
                }
            </mat-drawer-content>
            <mat-drawer
                id="sidebar"
                class="sidebar"
                data-tfa="sidebar"
                [position]="'end'"
                [mode]="'side'"
                [opened]="sidebarOpened$ | async"
                disableClose
            >
                <app-sidebar></app-sidebar>
            </mat-drawer>
        </mat-drawer-container>
        }
    </div>
</div>
